module.exports = __webpack_public_path__ + "static/img/3_1.d678d844.jpg";